import { StyledButton } from "./styled";
import { IButtonProps } from "./types";

const Button = ({children, color = "primary", ...props}: IButtonProps)=>(
    <StyledButton {...props} customColor={color}>
        {children}
    </StyledButton>
)

export {Button}